import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {FormStep} from '../../constants'
import c from '../classnames.scss'
import {FormButton} from '../form-button/form-button'
import {FormSteps} from '../form-steps'
import {Step} from '../form-steps/interfaces'
import {RegistrationLayout} from '../registration-layout'
import {Summary} from '../summary'
import {RsvpFormContainer} from './container'
import {RsvpFormProps} from './interfaces'
import s from './rsvp-form.scss'

export const RsvpForm = ({
  closedRegistrationMessage,
  registrationClosed,
  memberRsvpReady,
  memberRsvpExists,
  ticketedEvent,
  shouldNavigateToForm,
  navigateToMainPage,
  formPageLoaded,
  scrollToElement,
}: RsvpFormProps) => {
  const {t} = useTranslation()

  React.useEffect(() => {
    formPageLoaded()
  }, [])

  if (!memberRsvpReady || (memberRsvpExists && !ticketedEvent && !shouldNavigateToForm)) {
    return null
  }

  const containerClass = classNames(c.formBackgroundColor)

  if (registrationClosed) {
    return (
      <div className={classNames(containerClass, s.closedRegistrationMessageContainer)}>
        <div className={classNames(s.closedRegistrationMessage, c.formTitleFont, c.formTitleColor)}>
          {closedRegistrationMessage.message}
        </div>
        <FormButton
          text={closedRegistrationMessage.exploreEventsActionLabel}
          width="auto"
          onClick={() => navigateToMainPage()}
        />
      </div>
    )
  }

  return (
    <RsvpFormContainer>
      {(steps: Step[], currentStep: FormStep) => (
        <div data-hook={DH.RSVP_FORM} className={containerClass}>
          <RegistrationLayout
            Right={<Summary />}
            Left={<FormSteps currentStep={currentStep} steps={steps} t={t} scrollToElement={scrollToElement} />}
          />
        </div>
      )}
    </RsvpFormContainer>
  )
}
